var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBox(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 13,
    viewBox: "0 0 12 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.4869 0.789748L10.8505 2.97157C11.0323 3.06188 11.1852 3.20111 11.2922 3.37359C11.3992 3.54607 11.4559 3.74497 11.456 3.94793V9.14611C11.4559 9.34907 11.3992 9.54797 11.2922 9.72045C11.1852 9.89293 11.0323 10.0322 10.8505 10.1225L6.4869 12.3043C6.33534 12.3801 6.1682 12.4196 5.99872 12.4196C5.82924 12.4196 5.6621 12.3801 5.51054 12.3043L1.1469 10.1225C0.965336 10.031 0.812948 9.89059 0.706931 9.7171C0.600914 9.54362 0.545487 9.34396 0.546901 9.14066V3.94793C0.547009 3.74497 0.603731 3.54607 0.71069 3.37359C0.817649 3.20111 0.970604 3.06188 1.15236 2.97157L5.51599 0.789748C5.66684 0.714789 5.833 0.675781 6.00145 0.675781C6.16989 0.675781 6.33605 0.714789 6.4869 0.789748V0.789748Z",
    stroke: "#51B15C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0.722656 3.35938L6.00266 5.99937L11.2827 3.35938M6.00266 12.4139V5.99937",
    stroke: "#51B15C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBox);
export default __webpack_public_path__ + "static/media/box.b72b4bec8809c51fd4e391ed92df813d.svg";
export { ForwardRef as ReactComponent };